import { Component, Input, Output, EventEmitter, Inject, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Component({
  selector: 'ui-fh-form',
  templateUrl: './fh-form.component.html',
  styleUrls: ['./fh-form.component.scss']
})
export class FhFormComponent implements AfterViewInit {
  @Input() formName: FormGroup = new FormGroup({});
  @Input() submitLabel = '';
  @Input() submitIconOnly = false;
  @Input() submitIcon = '';
  @Input() submitLabelClass = '';
  @Input() submitLabelClassPosition = 'center';
  @Input() stickyBtn = false;
  @Input() formStyle: 'HORIZONTAL' | 'VERTICAL' = 'VERTICAL';
  @Input() class = '';
  @Input() btnLoading = false;
  @Input() btnAllowDisableAuto = true;
  @Input() btnDisabled = false;
  @Input() btnMinWidth: number | undefined;
  @Input() extraBtn: boolean = false;
  @Input() extraBtnLabel: string = '';
  @Input() extraBtnClass: string = '';
  @Input() extraBtnIcon: string = '';
  @Input() submitBtnId = '';
  @Output() submitForm: EventEmitter<void> = new EventEmitter<void>();
  @Output() extraBtnClick: EventEmitter<void> = new EventEmitter<void>();
  @Input() showFormBtn: boolean = true;
  @Input() showNotes: boolean = false;

  icon = this.appConfig.icon;

  constructor(@Inject(APP_CONFIG) protected appConfig: EnvironmentModel) {}

  ngAfterViewInit() {
    const loginBtn = document.getElementById('login-btn');
    if (loginBtn) {
      loginBtn.classList.add('login-btn-background');
    }
  }

  getStylesButton(): string {
    if (this.formStyle == 'HORIZONTAL') {
      return 'mt-4 ' + this.submitLabelClass;
    } else {
      // return "ms-4 " +this.submitLabelClass;
      return this.submitLabelClass;
    }
  }

  onSubmit() {
    this.submitForm.emit();
  }

  onExtraBtnClick() {
    this.extraBtnClick.emit();
  }
}
